module.exports = __webpack_public_path__ + "h5/img/ava1 (2).36795fa6.png";